<template>
  <div class="container">
    <h2 class="library-current-books__title">
      {{ $t('$app.library_materials') + ':' }}
    </h2>
    <VRow v-if="filteredCurrentLibrary?.length">
      <VCol
        v-for="item in filteredCurrentLibrary"
        :key="item.id"
        xl="4"
        sm="6"
        xs="12"
      >
        <RouterLink
          style="text-decoration: none; color: inherit;"
          :to="`/library/book/${item.id}`"
        >
          <div class="library-current-books bvi-speech">
            <VCard class="library-current-books__card">
              <div class="library-current-books__img-group">
                <img
                  v-if="item.cover"
                  class="library-current-books__img"
                  :src="`/${ item.cover }`"
                  alt="img"
                >
                <img
                  v-else
                  class="library-current-books__img-default"
                  src="/assets/images/default-document-cover.svg"
                  alt="img"
                >
              </div>
              <div class="library-current-books__items">
                <VCardTitle
                  v-show="item.title"
                  :title="item.title"
                  class="library-current-books__card-title"
                >
                  {{ shortenedLibraryTitle (item) }}
                </VCardTitle>
                <ul class="library-current-books__tags">
                  <li
                    v-for="tag in shortenedLibraryTags (item)"
                    :key="tag.id"
                    :title="tag"
                    class="library-current-books__tag"
                  >
                    {{ tag }}
                  </li>
                </ul>
                <VCardText v-show="item.author">
                  <strong>{{ $t('$app.library_author') + ':' }} </strong>{{ shortenedLibraryAuthor (item) }}
                </VCardText>
                <VCardText v-show="item.publication_year">
                  <strong>{{ $t('$app.library_publication_year') + ':' }} </strong>{{ item.publication_year }}
                </VCardText>
              </div>
            </VCard>
          </div>
        </RouterLink>
      </VCol>
    </VRow>
    <UPlaceholder v-else />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as getters from '@/store/getters/types'
import * as actions from '@/store/actions/types'
import UPlaceholder from '@components/UPlaceholder.vue'

export default {
  name: 'LibraryCurrentBooks',
  components: {
    UPlaceholder
  },

  props: {
    search: {
      type: String,
      default: '',
    }
  },

  computed: {
    ...mapGetters({
      library: getters.LIBRARY,
      libraryCurrentCatalog: getters.LIBRARY_CURRENT_CATALOG,
    }),

    filteredCurrentLibrary () {
      if (this.search) {
        const search = this.search.toUpperCase()
        return this.libraryCurrentCatalog?.filter((document) => {
          const titleMatch = document.title.toUpperCase().includes(search)
          const authorMatch = document.author.toUpperCase().includes(search)
          const yearMatch = document.publication_year.toUpperCase().includes(search)
          const tagsMatch = (document.tags ?? []).filter((tag) => {
            return tag.toUpperCase().includes(search)
          }).length > 0

          return titleMatch || authorMatch || tagsMatch || yearMatch
        })
      }
      return this.libraryCurrentCatalog
    }
  },

  watch: {
    $route () {
      this.getLibraryCurrentCatalog(this.$route.params.id)
    }
  },

  created () {
    this.getLibraryCurrentCatalog(this.$route.params.id)
  },

  methods: {
    ...mapActions({
      getLibraryCurrentCatalog: actions.GET_LIBRARY_CURRENT_CATALOG
    }),
    shortenedLibraryTitle (item) {
      if (item.title.length > 60) {
        return item.title.slice(0, 60) + '...'
      } else {
        return item.title
      }
    },

    shortenedLibraryAuthor (item) {
      if (item.author.length > 20) {
        return item.author.slice(0, 20) + '...'
      } else {
        return item.author
      }
    },

    shortenedLibraryTags (item) {
      if (item.tags_count > 3) {
        return item.tags.slice(0, 3)
      } else {
        return item.tags
      }
    }
  }
}
</script>

<style lang="scss">
.library-current-books .bvi-speech-text {
  height: 100%;
}

.library-current-books  {
  height: 100%;
}

.library-current-books__title {
  margin-bottom: 1rem;
}

.library-current-books__tags {
  padding: 10px;
}

.library-current-books__tag {
  display: inline-block;
  max-width: 6em;
  font-size: 0.75em;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0.5ch 1ch;
  padding: 0.5ch 1ch;
  border-radius: 0.75em;
  background-color: var(--v-background-base);
  border: solid 1px var(--v-text-base);
  color: var(--v-text-base);
}

.library-current-books__img-group {
  display: contents;
}

.library-current-books__img,
.library-current-books__img-default {
  width: 50%;
  padding: 1rem;
  object-fit: contain;
}

.library-current-books__items {
  display: flex;
  justify-content: space-between;
  width: 50%;
  flex-direction: column;
}

.library-current-books__card {
  display: flex;
  height: 100%;
  width: 100%;
  min-height: 312px;
  transition: linear 0.1s;
}

.library-current-books__card:hover {
  opacity: 0.8;
}

.library-current-books__card-title {
  display: block;
}
</style>
